import { Purpose } from '@axo/shared/data-access/types';

type GetPurposeParams = {
  totalRefinanceAmount: number;
  initialPurpose: Purpose;
  currentPurpose: Purpose;
};

export const getPurpose = ({
  totalRefinanceAmount,
  initialPurpose,
  currentPurpose,
}: GetPurposeParams) => {
  if (totalRefinanceAmount === 0) {
    if (currentPurpose !== Purpose.RefinancingLoan) return currentPurpose;

    if (
      currentPurpose === Purpose.RefinancingLoan &&
      initialPurpose === Purpose.RefinancingLoan
    )
      return Purpose.Other;

    return initialPurpose;
  }

  if (totalRefinanceAmount > 0 && currentPurpose === Purpose.Other) {
    return Purpose.RefinancingLoan;
  }

  return currentPurpose;
};
